<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="page-wrap page-tab-detail-area">
    <jw-card style="width: 100%; height: 100%" :bordered="false">
      <div class="detail-header">
        <div class="drag-content" ref="contentScrollRef" v-if="visible">
          <!-- 页签区域 -->
          <draggable :disabled="isSysLayout" itemKey="index" @start="onStart" @end="onEnd" :move="onMoveTab" :list="tabDetailList" class="drag-able" ref="tabScrollRef">
            <template #item="{ element, index }">
              <div class="drag-detail hand">
                <div class="drag-detail-item tab-item" @click="switchTabs(element, index)" :class="[index == data.tabIndex ? 'active-drag-item' : '', activeTab && index == data.tabIndex && data.active === 'details' ? 'item-click' : '', isSysLayout ? 'layout-unsplit' : '']">
                  <qfei-icon-more-two-outlined v-if="!isSysLayout" class="title-mover" />
                  <span class="drag-item-title">{{ element.label }}</span>
                  <jw-popover trigger="click" v-if="!isSysLayout" position="bottom" popup-container=".page-tab-detail-area" :scroll-to-close="true">
                    <div class="more-popover">
                      <qfei-icon-more-applications-outlined class="icon-more-circle" strokeWidth="6" />
                    </div>
                    <template #content>
                      <jw-space direction="vertical">
                        <jw-button v-if="tabDetailList.length > 1" long size="mini" type="text" status="danger" @click="deleteDetailItem(index, element)">{{ $t('删除') }}</jw-button>
                        <jw-button class="popover-btn" long size="mini" type="text" @click="copyDetailItem(element)">{{ entityStore.entityGray ? $t('复制') : $t('复制到当前布局') }}</jw-button>
                        <jw-button v-if="!entityStore.entityGray" class="popover-btn" long size="mini" type="text" @click="handleClick(element, 20)">{{ $t('复制到其他布局') }}</jw-button>
                      </jw-space>
                    </template>
                  </jw-popover>
                </div>
              </div>
            </template>
          </draggable>
        </div>
        <jw-modal width="400px" v-model:visible="data.modalVisible" @cancel="handleCancel('modalVisible')" title-align="start" :on-before-ok="handleOk" unmountOnClose>
          <template #title>
            {{ data.modalType == 20 ? $t('复制到其他布局') : $t('复制到其他布局页签') }}
          </template>
          <div class="tips-con-text">
            {{ data.modalType == 20 ? $t('tips.tabsToOtherLayouts') : $t('tips.copyToOtherTips') }}
          </div>
          <jw-form :model="data.form" @submit="handleSubmit" ref="formRef" label-align="left" class="modal-form">
            <jw-form-item field="selectdata" :rules="{ required: true, message: data.modalType == 20 ? $t('请选择目标布局') : $t('请选择目标页签') }" :validate-trigger="['change', 'input', 'blur']" class="form-label-text" :label-col-props="{ span: 6 }" :wrapper-col-props="{ span: 18 }">
              <template #label>
                <xl-label-text cursor="pointer" :value="$t('目标布局')" :row="1" />
              </template>
              <jw-select width="200px" v-if="data.modalType == 20" v-model="data.form.selectdata" :placeholder="$t('请选择目标布局')" allow-clear allow-search :virtual-list-props="{ height: 200 }" :field-names="{ value: 'id', label: 'name' }" :options="selectList" :loading="selectLoading"> </jw-select>
              <jw-cascader :trigger-props="{ updateAtScroll: true }" v-else-if="data.modalType === 10" :options="selectList" :placeholder="$t('请选择目标页签')" :field-names="{ value: 'id', label: 'name', children: 'modules' }" v-model="data.form.selectdata" allow-clear path-mode />
            </jw-form-item>
          </jw-form>
        </jw-modal>
        <jw-modal width="400px" v-model:visible="data.moveModalVisible" @cancel="handleCancel('moveModalVisible')" title-align="start" :on-before-ok="moveModalHandleOk" unmountOnClose>
          <template #title>
            {{ $t('移动到分组') }}
          </template>
          <div class="tips-con-text">
            {{ $t('tips.moveToOtherTips') }}
          </div>
          <jw-form :model="data.moveToGroupForm" @submit="moveModalSubmit" ref="moveModalFormRef" label-align="left" class="modal-form">
            <jw-form-item field="selectdata" :rules="{ required: true, message: $t('请选择目标分组') }" :validate-trigger="['change', 'input', 'blur']" class="form-label-text" :label-col-props="{ span: 6 }" :wrapper-col-props="{ span: 18 }">
              <template #label>
                <xl-label-text cursor="pointer" :value="$t('目标分组')" :row="1" />
              </template>
              <jw-select v-model="data.moveToGroupForm.selectdata" :placeholder="$t('请选择目标分组')" allow-clear allow-search :virtual-list-props="{ height: 200 }" :options="moveToGroupList">
                <!-- <jw-option v-for="(forItem,forIndex) in moveToGroupList" :key="forIndex" :value="forItem?.value" :title="forItem.label" :disabled="forIndex == data.moveToGroupData[1]">{{ forItem?.label }}</jw-option> -->
              </jw-select>
            </jw-form-item>
          </jw-form>
        </jw-modal>
        <jw-modal width="400px" v-model:visible="data.copyToOtherVisible" title-align="start" @cancel="copyToOtherCancel" :on-before-ok="copyToOtherOk" unmountOnClose>
          <template #title>
            {{ $t('复制到其他页签') }}
          </template>
          <div class="tips-con-text">
            {{ $t('tips.copyToOtherTips') }}
          </div>
          <jw-form :model="data.copyToOtherForm" @submit="copyToOtherSubmit" ref="copyToOtherRef" label-align="left" class="modal-form">
            <jw-form-item field="selectdata" :rules="{ required: true, message: $t('请选择目标页签') }" :validate-trigger="['change', 'input', 'blur']" class="form-label-text" :label-col-props="{ span: 6 }" :wrapper-col-props="{ span: 18 }">
              <template #label>
                <xl-label-text cursor="pointer" :value="$t('目标页签')" :row="1" />
              </template>
              <jw-select v-model="data.copyToOtherForm.selectdata" :placeholder="$t('请选择目标页签')" allow-clear allow-search :virtual-list-props="{ height: 200 }" :options="tabDetailListSelect"> </jw-select>
            </jw-form-item>
          </jw-form>
        </jw-modal>
        <jw-dropdown position="br" @select="addTabPage" v-if="!isSysLayout">
          <div class="add-tab-page">
            <div class="add-tab-text">
              <icon-plus style="margin-right: 5px" />
              <span>{{ $t('新增页签') }}</span>
            </div>
          </div>
          <template #content>
            <jw-doption v-for="item in tabNoShowList" :key="item.value" :value="item">{{ item.label }}</jw-doption>
          </template>
        </jw-dropdown>
      </div>
      <div class="layout-system-modules" v-if="tabDetailList[data.tabIndex]?.value && tabDetailList[data.tabIndex]?.value != 1">
        <div style="text-align: center">
          <qf-icon-tixing />
          <p>{{ $t('该页面不支持配置') }}</p>
        </div>
      </div>
      <div class="detail-body" v-else>
        <!-- {{ tabDetailList }} -->
        <!-- <template v-if="tabDetailList?.[data.tabIndex]?.modules?.length > 0"> -->
        <draggable v-if="visibleInput" :disabled="isSysLayout || focusEl" itemKey="index" @start="onStart" @end="onEnd" :move="onMove" :list="tabDetailList[data.tabIndex]?.modules" class="draggable-detail-content" ref="groupListRef">
          <template #item="{ element, index }">
            <div class="drag-detail-item draggable-detail-content-item">
              <!-- 此处是每一个分组 -->
              <qfei-icon-more-two-outlined class="mover mover-icon" :class="isSysLayout ? 'mover-icon-disabled' : ''" />
              <div class="drag-item-content">
                <div class="drag-item-title hand">
                  <icon-caret-right @click="switchExpandContent(element)" :style="{ fontSize: '14px' }" />
                  <jw-input :disabled="isSysLayout" v-model="element.label" @focus="handleFocus()" @blur="handleBlur()" :placeholder="$t('请输入分组名称')" class="item-title-input"> </jw-input>
                  <div class="operate-bottoms" v-if="!isSysLayout">
                    <jw-popover trigger="click" position="bottom" popup-container=".page-tab-detail-area" :scroll-to-close="true">
                      <jw-tooltip :content="$t('复制')" position="top" mini>
                        <qfei-icon-copy-outlined class="icon-btn icon-copy-circle" size="18px" />
                      </jw-tooltip>
                      <template #content>
                        <jw-space direction="vertical">
                          <jw-button class="popover-btn" long size="mini" type="text" @click="copyToCurrent(element)">{{ $t('复制到当前页签') }}</jw-button>
                          <jw-button class="popover-btn" long size="mini" type="text" @click="copyToOther(element)">{{ $t('复制到其他页签') }}</jw-button>
                          <jw-button class="popover-btn" v-if="!entityStore.entityGray" long size="mini" type="text" @click="handleClick(element, 10)">{{ $t('复制到其他布局') }}</jw-button>
                        </jw-space>
                      </template>
                    </jw-popover>
                    <jw-tooltip v-if="isSecondLevel(element)" :content="$t('移动到分组')" position="top" mini>
                      <qfei-icon-move-outlined class="icon-btn icon-send-circle" size="18px" @click.stop.prevent="moveToGroup(index, -1)" />
                    </jw-tooltip>
                    <jw-tooltip :content="$t('添加新分组')" position="top" mini>
                      <qfei-icon-folder-add-outlined class="icon-btn icon-add-circle" size="18px" @click.stop.prevent="addNewGroup(index)" />
                    </jw-tooltip>
                    <jw-tooltip :content="$t('删除')" position="top" mini>
                      <qfei-icon-close-two-outlined class="icon-btn icon-delete-circle" size="18px" @click.stop.prevent="deleteGroup(index, -1)" />
                    </jw-tooltip>
                  </div>
                </div>
                <!-- 此处是分组内部字段容器 -->
                <div v-if="!element?.isExpandContent" class="drag-item-content-layout">
                  <draggable :group="{ name: 'itxst', sort: true, pull: true }" :disabled="isSysLayout || focusEl" itemKey="index" @start="onStart" @end="onEnd" :move="onMove" :list="element.modules" :class="['draggable-abstract draggable-abstract2']" :ghostClass="ghostClass">
                    <template #item="{ element: ele, index: i }">
                      <div :class="['hand', 'drag-item-list', `drag-sub-form-item`, `drag-item-list-table${ele.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" @click="selectContentItem(index, i, -1, ele, 'table')" v-if="getRecordType(ele?.layoutFieldType || ele?.type)">
                        <div :class="['drag-item-list-table-hover', clickIndex == i && parentIndex == index && data.active === 'details' ? 'item-click' : '', 'drag-item-list-hover']" :data-parentIndex="index" :data-index="i">
                          <div class="drag-sub-form-item-title" :style="{ maxWidth: 'calc(100% - 20px)', paddingRight: '4px' }">
                            <qfei-icon-more-two-outlined :class="isSysLayout ? 'mover-icon-disabled' : ''" class="drag-mover" />
                            <component class="filed-icon" :is="componentFun(ele)" />
                            <!-- 30:关联记录，31：查询记录 -->
                            <xl-label-text cursor="pointer" :value="setRecordLabel(ele)" :row="1" :key="ele.toast" />
                          </div>
                          <association-table :source="20" :ele="ele" :additionalBusiness="ele?.additionalBusiness"></association-table>
                          <qfei-icon-close-two-outlined v-if="splitType != 2" :class="['icon-close-circle', clickIndex == i && parentIndex == index && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, -1, ele)" />
                        </div>
                        <div class="hint" :style="{ paddingLeft: '10px' }" v-if="!ele?.businessData">请完善组件的必填内容</div>
                      </div>

                      <div v-else-if="ele?.layoutFieldType == 35 || ele?.type == 35" :class="['drag-item-list', 'hand', `drag-sub-form-item`, `drag-sub-form-item${ele.layoutFieldType}`, `${ele.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" @click.stop.prevent="selectContentItem(index, i, -1, ele, '', true)">
                        <!-- 子表单 -->
                        <div :class="['drag-item-list-hover', 'drag-item-list-table-hover', clickIndex == i && parentIndex == index && data.active === 'details' ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                          <detail-sub-form-table :element="ele" :formAttribute="data.formAttribute" :parentIndex="index" :index="i" :ref="($event) => setRef($event, ele?.id || ele?.uniqueValue)" />
                          <qfei-icon-close-two-outlined v-if="!isSysLayout" :class="['icon-close-circle', clickIndex == i && parentIndex == index && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, -1, ele)" />
                        </div>
                      </div>

                      <!-- 外链容器 -->
                      <div :class="['hand', 'drag-item-list', `drag-sub-form-item`, `${ele.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" data-a="hand drag-item-list drag-sub-form-item" @click="selectContentItem(index, i, -1, ele, 'outLink', false)" v-else-if="ele?.layoutFieldType == 60 || ele?.type == 60">
                        <div :class="['drag-item-list-hover', 'drag-item-list-table-hover', 'drag-item-frame', activeField && clickIndex == i && parentIndex == index && sonIndex == '-1' && data.active === 'details' ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                          <qfei-icon-more-two-outlined :class="isSysLayout ? 'mover-icon-disabled' : ''" class="mover table-mover" />
                          <div :class="['empty-subfield', `${ele.layoutFieldType}`]">{{ $t('外链容器') }}</div>
                          <qfei-icon-close-two-outlined v-if="!isSysLayout" :class="['icon-close-circle', activeField && clickIndex == i && parentIndex == index && sonIndex == '-1' && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, -1, ele)" />
                        </div>
                      </div>
                      <div class="detail-body" v-else-if="ele?.layoutFieldType == 10 || ele?.type == 10">
                        <div class="drag-detail-item">
                          <qfei-icon-more-two-outlined :class="isSysLayout ? 'mover-icon-disabled' : ''" class="mover mover-icon" />
                          <div class="drag-item-content">
                            <div class="drag-item-title hand">
                              <icon-caret-right @click="switchExpandContent(ele)" :style="{ fontSize: '14px' }" />
                              <jw-input :disable="isSysLayout" v-model="ele.label" @focus="handleFocus()" @blur="handleBlur()" :placeholder="$t('请输入分组名称')" class="item-title-input"></jw-input>
                              <div class="operate-bottoms" v-if="!isSysLayout">
                                <jw-popover trigger="click" position="bottom" popup-container=".page-tab-detail-area" :scroll-to-close="true">
                                  <jw-tooltip :content="$t('复制')" position="top" mini>
                                    <qfei-icon-copy-outlined class="icon-btn icon-copy-circle" size="18px" />
                                  </jw-tooltip>
                                  <template #content>
                                    <jw-space direction="vertical">
                                      <jw-button class="popover-btn" long size="mini" type="text" @click="copyToCurrent(ele)">{{ $t('复制到当前页签') }}</jw-button>
                                      <jw-button class="popover-btn" long size="mini" type="text" @click="copyToOther(ele)">{{ $t('复制到其他页签') }}</jw-button>
                                      <jw-button class="popover-btn" v-if="!entityStore.entityGray" long size="mini" type="text" @click="handleClick(ele, 10)">{{ $t('复制到其他布局') }}</jw-button>
                                    </jw-space>
                                  </template>
                                </jw-popover>
                                <jw-popover trigger="click" position="bottom" popup-container=".page-tab-detail-area" :scroll-to-close="true">
                                  <jw-tooltip :content="$t('移动')" position="top" mini>
                                    <qfei-icon-move-outlined class="icon-btn icon-send-circle" size="18px" />
                                  </jw-tooltip>
                                  <template #content>
                                    <jw-space direction="vertical">
                                      <jw-button class="popover-btn" long size="mini" type="text" @click="moveToGroup(index, i)">{{ $t('移动到分组') }}</jw-button>
                                      <jw-button class="popover-btn" long size="mini" type="text" @click="removeFromGroup(index, i)">{{ $t('移出') }}</jw-button>
                                    </jw-space>
                                  </template>
                                </jw-popover>
                                <jw-tooltip :content="$t('删除')" position="top" mini>
                                  <qfei-icon-close-two-outlined class="icon-btn icon-delete-circle" size="18px" @click.stop.prevent="deleteGroup(index, i)" />
                                </jw-tooltip>
                              </div>
                            </div>
                            <div v-if="!ele?.isExpandContent" class="drag-item-content-layout drag-item-level-content-layout">
                              <draggable :group="{ name: 'itxst', sort: true, pull: true }" itemKey="i" @start="onStart" @end="onEnd" :move="onMove" :list="ele.modules" :class="['draggable-abstract draggable-abstract3']" :ghostClass="ghostClass">
                                <template #item="{ element: eleLevel, index: iLevel }">
                                  <div :class="['drag-item-list', 'hand', 'drag-sub-form-item', `drag-item-list-table${eleLevel.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" @click="selectContentItem(index, i, iLevel, eleLevel, 'table')" v-if="getRecordType(eleLevel?.layoutFieldType || eleLevel?.type)">
                                    <div :class="['drag-item-list-hover', 'drag-item-list-table-hover', , clickIndex == i && parentIndex == index && sonIndex == iLevel && data.active === 'details' ? 'item-click' : '']" :data-parentIndex="index" :data-index="i" :data-childIndex="iLevel" :style="{ flexDirection: 'column' }">
                                      <div class="drag-sub-form-item-title" :style="{ maxWidth: 'calc(100% - 20px)', paddingRight: '4px' }">
                                        <qfei-icon-more-two-outlined :class="isSysLayout ? 'mover-icon-disabled' : ''" class="drag-mover" />
                                        <component class="filed-icon" :is="componentFun(eleLevel)" />
                                        <!-- 30:关联记录，31：查询记录 -->

                                        <xl-label-text cursor="pointer" :value="setRecordLabel(eleLevel)" :row="1" :key="eleLevel.toast" />
                                      </div>
                                      <association-table :source="20" :ele="eleLevel" :additionalBusiness="eleLevel?.additionalBusiness"></association-table>
                                      <qfei-icon-close-two-outlined :class="['icon-close-circle', clickIndex == i && parentIndex == index && sonIndex == iLevel && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, iLevel, eleLevel)" />
                                      <span class="hint" v-if="!eleLevel?.businessData">请完善组件的必填内容</span>
                                    </div>
                                  </div>
                                  <div :class="['drag-item-list', 'hand', `drag-sub-form-item`, `${eleLevel.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" data-a="hand drag-item-list drag-sub-form-item" @click.stop.prevent="selectContentItem(index, i, iLevel, eleLevel, '', true)" v-else-if="eleLevel?.layoutFieldType == 35 || eleLevel?.type == 35">
                                    <!-- 子表单 -->
                                    <div :class="['drag-item-list-hover', 'drag-item-list-table-hover', clickIndex == i && parentIndex == index && sonIndex == iLevel && data.active === 'details' ? 'item-click' : '']" :data-parentIndex="index" :data-index="i" :data-childIndex="iLevel" :style="{ flexDirection: 'column' }">
                                      <detail-sub-form-table :element="eleLevel" :parentIndex="index" :index="i" :levelIndex="iLevel" :formAttribute="data.formAttribute" :ref="($event) => setRef($event, eleLevel?.id || eleLevel?.uniqueValue)" />
                                      <qfei-icon-close-two-outlined :class="['icon-close-circle', clickIndex == i && parentIndex == index && sonIndex == iLevel && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, iLevel, eleLevel)" />
                                    </div>
                                  </div>
                                  <div :class="['hand', 'drag-item-list', `drag-sub-form-item`, `${eleLevel.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" data-a="hand drag-item-list drag-sub-form-item" @click="selectContentItem(index, i, iLevel, eleLevel, 'outLink', false)" v-else-if="eleLevel?.layoutFieldType == 60 || eleLevel?.type == 60">
                                    <div :class="['drag-item-list-hover', 'drag-item-list-table-hover', 'drag-item-frame', activeField && clickIndex == i && parentIndex == index && sonIndex == iLevel ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                                      <qfei-icon-more-two-outlined :class="isSysLayout ? 'mover-icon-disabled' : ''" class="drag-mover" />
                                      <component class="filed-icon" :is="componentFun(eleLevel)" />
                                      <div :class="['empty-subfield', `${eleLevel.layoutFieldType}`]">{{ $t('外链容器') }}</div>
                                      <qfei-icon-close-two-outlined :class="['icon-close-circle', activeField && clickIndex == i && parentIndex == index && sonIndex == iLevel ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, iLevel, eleLevel)" />
                                    </div>
                                  </div>
                                  <div v-else :class="getDragItemClass(eleLevel)" @click="selectContentItem(index, i, iLevel, eleLevel, 'field')">
                                    <div :class="['drag-item-list-hover', 'group-field', activeField && clickIndex == i && parentIndex == index && sonIndex == iLevel && data.active === 'details' ? 'item-click' : '', isCustomLayout ? 'custom-layout' : '']" :data-parentIndex="index" :data-index="i" :data-childIndex="iLevel">
                                      <tab-detail-label :ele="eleLevel"></tab-detail-label>
                                      <qfei-icon-close-two-outlined :class="['icon-close-circle', activeField && clickIndex == i && parentIndex == index && sonIndex == iLevel && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, iLevel, eleLevel)" />
                                      <span class="drag-item-memo" v-if="eleLevel?.memo">{{ eleLevel?.memo }}</span>
                                    </div>
                                  </div>
                                </template>
                                <!-- 当列表为空时显示的内容 -->
                                <template #footer v-if="!ele.modules?.length || !ele?.modules">
                                  <div class="empty-modules">{{ $t('暂无内容') }}</div>
                                </template>
                              </draggable>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else :class="[getDragItemClass(ele), curDragItemClass]" @click="selectContentItem(index, i, -1, ele, 'field')">
                        <div :class="['drag-item-list-hover', activeField && clickIndex == i && parentIndex == index && sonIndex == '-1' && data.active === 'details' ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                          <tab-detail-label :ele="ele"></tab-detail-label>
                          <qfei-icon-close-two-outlined v-if="!isSysLayout" :class="['icon-close-circle', activeField && clickIndex == i && parentIndex == index && sonIndex == '-1' && data.active === 'details' ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteContentItem(index, i, -1, ele)" />
                          <span class="drag-item-memo" :style="{ paddingLeft: data.formAttribute?.formLayout ? '0' : '125px' }" v-if="ele?.memo">{{ ele?.memo }}</span>
                        </div>
                      </div>
                    </template>
                    <!-- 当列表为空时显示的内容 -->
                    <template #footer v-if="!element.modules?.length || !element?.modules">
                      <div class="empty-modules">{{ $t('暂无内容') }}</div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </jw-card>
  </div>
</template>

<script setup>
import { reactive, ref, inject, onMounted, watch, computed, nextTick, provide } from 'vue';
import associationTable from '../association-table/association-table.vue';
import tabDetailLabel from '../tab-detail-label/tab-detail-label.vue';
import draggable from 'vuedraggable';
import { Message } from '@arco-design/web-vue';
import { setService } from '@/api/';
import { Modal } from '@arco-design/web-vue';
// import { tools } from '@/utils/tools.js';
import { QfeiIconCloseTwoOutlined, QfeiIconMoveOutlined, QfeiIconCopyOutlined, QfeiIconFolderAddOutlined, QfeiIconMoreTwoOutlined, QfeiIconMoreApplicationsOutlined } from '@qfei-design/icons-vue';
import detailSubFormTable from '@/views/setting/sys-fields/page-layout/components/detail-sub-form-table/detail-sub-form-table.vue';
import { layoutBuiltObj } from '@/utils/const';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useUserStore, useEntityGrayStore, useLayoutStore } from '@/store';

import useObjectForm from '@/hooks/object-form';
const entityStore = useEntityGrayStore(); // 对象灰度

const { getRecordType, setRecordLabel, componentFun } = useObjectForm();

const useLayout = useLayoutStore(); //日程store
const { userInfo } = useUserStore();
const route = useRoute();
const { t } = useI18n();
const emits = defineEmits(['sendData', 'tabList', 'cb']);
const props = defineProps({
  tabList: {
    type: Array,
    default: () => []
  },
  layoutId: {
    type: Number,
    default: () => null
  }
});
const contentScrollRef = ref(); // 页签头部区域
const groupListRef = ref(null);
const tabScrollRef = ref(null);
const subFormDataRefs = reactive({}); //子表单的ref
const setRef = (e, id) => {
  //设置ref
  subFormDataRefs[`subForm${id}`] = e;
};
const data = reactive({
  drag: false,
  modalVisible: false,
  modalType: null, //10 复制到其他布局页签；20 复制到其他布局
  moveModalVisible: false,
  moveToGroupData: [], //分组移动数据
  form: {
    selectdata: null
  },
  copyToOtherVisible: false,
  copyToOtherForm: {
    selectdata: null
  },
  moveToGroupForm: {
    selectdata: null
  },
  tabIndex: 0,
  operationType: inject('sharedConfigData')?.operationType,
  active: inject('sharedConfigData')?.active,
  pId: inject('sharedConfigData')?.pId,
  loading: inject('sharedConfigData')?.loading,
  layoutBuiltList: [],
  displayOneLineFields: [18, 26], //整行显示的字段
  formAttribute: inject('sharedConfigData')?.formAttribute
});
const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式
const orderService = [
  { label: '客户关键联系人', value: 'customerLinkMan' },
  { label: '客户特征', value: 'feature' },
  { label: '客户伙伴数据(天维度)', value: 'partner' }
];

// 与表单设计同步
const isSysLayout = computed(() => {
  return splitType?.value == 2;
});

// 自定义布局
const isCustomLayout = computed(() => {
  return splitType?.value == 3;
});

console.log('dataPid', data.pId);
// const xlUserTable1=ref(); //第一级表格
// const xlUserTable2=ref();//第二级表格
const tabDetailList = ref(props.tabList); //根据详情接口返回的直接展示到页签栏的数据
const tabDetailListSelect = ref(tabDetailList.value.map((el, index) => ({ label: el.label, value: index })).filter((item, i) => i != data.tabIndex));
const dlv = computed(() => tabDetailList.value?.filter((v) => v.value)); //过滤出系统页签
const initTabList = computed(() => {
  if (Number(data.pId) >= 200) {
    return [{ label: '审批记录', value: 'approvalRecord' }];
  }
  return layoutBuiltObj[data.pId == '101' ? '1' : data.pId]?.filter((v) => v.value);
});

console.log('默认tab', initTabList, dlv);

if (userInfo.orgId == 3 && data.pId === 12) {
  initTabList.value = dlv.value.filter((v) => !orderService.some((m) => m.value === v.value));
  initTabList.value.push(...orderService);
  console.log(139, dlv.value);
}
console.log(116, 219, initTabList);

const tabNoShowList = computed(() => {
  const lt = initTabList.value?.filter((v) => !dlv.value.some((m) => m.value === v.value)) ?? [];
  console.log(146, lt);
  const list = [
    {
      type: 260,
      value: '1',
      label: t('新增页签'),
      display: 1,
      displayConditions: [],
      modules: []
    },
    ...lt
  ];
  return list;
});
const focusEl = ref(false);
const handleFocus = () => {
  focusEl.value = true;
};
const handleBlur = () => {
  focusEl.value = false;
};
// const name = ref();
// 开始拖拽事件
const onStart = (e) => {
  data.drag = true;
  useLayout.setDrag(true);
  useLayout.setDragLayoutType(parseInt(e?.item?.__draggable_context?.element?.layoutFieldType));
};
//拖拽结束事件
const onEnd = () => {
  console.log('结束3 ');
  updataConfig();
};
const updataConfig = () => {
  const content = document.querySelectorAll('.draggable-abstract2');
  for (var i = 0; i < content?.length; i++) {
    if (content[i]?.querySelectorAll('.item-click')) {
      const itemClickElements = content[i]?.querySelectorAll('.item-click');
      const parentIndex = itemClickElements?.[0]?.dataset.parentindex;
      const childIndex = itemClickElements?.[0]?.dataset.index;
      const sonIndex = itemClickElements?.[0]?.dataset.childindex;

      if ((parentIndex || parentIndex == 0) && (childIndex || childIndex == 0)) {
        let modules;
        if (sonIndex || sonIndex == 0) {
          modules = tabDetailList.value[data.tabIndex]?.modules[parentIndex]?.modules[childIndex]?.modules[sonIndex];
        } else {
          modules = tabDetailList.value[data.tabIndex]?.modules[parentIndex]?.modules[childIndex];
        }
        // const modules = tabDetailList.value[data.tabIndex]?.modules[parentIndex]?.modules[childIndex];
        if (getRecordType(modules?.layoutFieldType) || modules?.layoutFieldType == 35) {
          //关联记录，查询记录
          activeTable.value = true; //表格

          activeField.value = false; //字段
        } else {
          //字段/关联对象字段等
          activeTable.value = false; //表格
          activeField.value = true; //字段
        }

        emits('sendData', { page: 20, groupIndex: parentIndex, index: childIndex, sonIndex: sonIndex || sonIndex == 0 ? sonIndex : -1, area: 'field', modules: modules, active: 'details' });
      }
    }
  }

  data.drag = false;
};
const activeTab = ref(false);
const activeTable = ref(false);
const activeField = ref(false);
const clickIndex = ref();
const parentIndex = ref();
const sonIndex = ref();
// 切换页签
const switchTabs = (record, index) => {
  console.log('record', record, index);
  activeTab.value = true;
  activeTable.value = false;
  activeField.value = false;
  data.tabIndex = index;
  clickIndex.value = -1;
  parentIndex.value = -1;
  sonIndex.value = -1;
  if (splitType?.value != 2) {
    emits('sendData', { page: 20, area: 'tab', index, modules: record, active: 'details' });
  }
};

// 切换显示状态
const switchExpandContent = (e) => {
  if (e?.isExpandContent == true) {
    e.isExpandContent = false;
  } else {
    e.isExpandContent = true;
  }
};

// 删除页签
const deleteDetailItem = (index, element) => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('tips.isDeleteTab'),
    content: element.value ? t('tips.isDeleteBuiltTabContent') : t('tips.isDeleteTabContent'),
    onOk: () => {
      tabDetailList.value.splice(index, 1);
      // 如果当前选中项被删除，则选中第一个
      // if (data.tabIndex === index) {
      // tab页激活项
      data.tabIndex = 0;
      nextTick(() => {
        contentScrollRef.value.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      });
      // }
    }
  });
};
const visible = ref(true); //更新页签
const visibleInput = ref(true); //更新分组
// 递归删除数据中的id,parentId
const updateNestedArrayValues = (data) => {
  // 检查当前对象是否有 id、parentId，如果有，则设置为 null
  if (data.id) {
    data.id = null;
  }
  if (data.parentId) {
    data.parentId = null;
  }
  // 如果有 modules，继续递归处理
  if (data.modules && Array.isArray(data.modules)) {
    for (const module of data.modules) {
      updateNestedArrayValues(module);
    }
  }
  // 如果有 displayConditions，继续递归处理
  if (data.children && Array.isArray(data.children)) {
    for (const childrenItem of data.children) {
      updateNestedArrayValues(childrenItem);
    }
  }
  if (data.displayConditions) {
    updateNestedArrayValues(data.displayConditions);
  }
};
// 复制分组到当前页签
const copyToCurrent = async (element) => {
  if (element.id && element?.modules?.length > 0) {
    await updateNestedArrayValues(element);
  }
  const copyItem = { ...element, label: (element.label ? element.label : '未命名分组') + '_拷贝' };
  tabDetailList.value[data.tabIndex]?.modules.push(JSON.parse(JSON.stringify(copyItem)));
  visibleInput.value = false;
  await nextTick(() => {
    visibleInput.value = true;
  });
  // 触发视图更新
  //   emits('cb');
  nextTick(() => {
    const parentDom = document.getElementsByClassName('draggable-detail-content')[0];
    const doms = parentDom.querySelectorAll('.draggable-detail-content-item');
    const dom = doms[doms.length - 1];
    const domHead = dom.querySelectorAll('.drag-item-title')[0];
    domHead.scrollIntoView({ behavior: 'smooth', block: 'center' }); //将当前选中页签滚动到可视范围且垂直居中 smooth：平滑过渡
  });
};
const copyToOtherItem = ref();
//复制分组到其他页签
const copyToOther = async (element) => {
  visibleInput.value = false;
  nextTick(() => {
    visibleInput.value = true;
  });
  data.copyToOtherForm.selectdata = null;
  data.copyToOtherVisible = true;
  if (element.id && element?.modules?.length > 0) {
    await updateNestedArrayValues(element);
  }
  copyToOtherItem.value = { ...element, label: (element.label ? element.label : '未命名分组') + '_拷贝' };
  // tabDetailList.value[data.tabIndex]?.modules.push(copyItem);
  // // 触发视图更新
  // emits('cb');
};
// 复制页签到当前布局
const copyDetailItem = async (element) => {
  if (element.id && element?.modules?.length > 0) {
    await updateNestedArrayValues(element);
  }
  const copyItem = { ...element, label: (element.label ? element.label : '未命名页签') + '_拷贝' };
  tabDetailList.value.push(JSON.parse(JSON.stringify(copyItem)));
  visible.value = false;
  await nextTick(() => {
    visible.value = true;
    nextTick(() => {
      if (tabScrollRef.value.$el.scrollWidth > tabScrollRef.value.$el.offsetWidth) {
        //滚动到最后并且切换tab页到新增的最后一个
        document.querySelector('.drag-content').scrollLeft = tabScrollRef.value.$el.scrollWidth;
        const _index = tabDetailList.value.length - 1;
        switchTabs(tabDetailList.value[_index], _index);
      } else {
        const _index = tabDetailList.value.length - 1;
        switchTabs(tabDetailList.value[_index], _index);
      }
    });
  });
};

const selectList = ref([]); //保存其他布局页签数据
const formRef = ref(null);
const moveToGroupList = ref([]); //当前页签下的分组列表
const moveModalFormRef = ref(null);
const copyToOtherRef = ref(null); //分组复制到其他标签
const copyToOtherLayoutData = ref({}); //复制到其他布局内容
const selectLoading = ref(false);
const pId = Number(route.params?.id ?? '101'); // 线索池使用销售线索id
// 将当前分组移动到其他一级分组
const moveToGroup = (fIndex, index) => {
  data.moveToGroupForm.selectdata = null;
  moveToGroupList.value = [];
  data.moveToGroupData = [fIndex, index];
  let noNameIndex = 0;
  if (index > -1) {
    //将二级分组移动到一级分组列表
    moveToGroupList.value = tabDetailList.value[data.tabIndex]?.modules
      ?.map((el, index) => {
        if (el.label) {
          return { label: el.label, value: index };
        } else {
          noNameIndex++;
          return { label: '未命名分组' + noNameIndex, value: index };
        }
      })
      .filter((item, i) => i != fIndex);
  } else {
    //将一级分组移动到一级分组列表
    moveToGroupList.value = tabDetailList.value[data.tabIndex]?.modules
      ?.filter((item, i) => i != fIndex)
      .map((el, index) => {
        if (el.label) {
          return { label: el.label, value: index };
        } else {
          noNameIndex++;
          return { label: '未命名分组' + noNameIndex, value: index };
        }
      });
  }
  data.moveModalVisible = true;
};

const getDragItemClass = (ele) => {
  // 基础类名数组，使用过滤移除空字符串
  const classes = ['drag-item-list', 'hand', splitType?.value === 2 ? 'drag-item-list-unover' : '', isCustomLayout.value ? 'custom-layout' : ''].filter(Boolean);

  // 处理显示相关的类名
  const { fieldType, displayOneLine } = ele || {};
  console.log('ele', ele, fieldType, displayOneLine, data.formAttribute);
  if (data.displayOneLineFields.includes(fieldType)) {
    classes.push('card-form-line');
  } else {
    if (displayOneLine === null) {
      // 当displayOneLine为null时，根据formAttribute判断，1表示一列，否则走默认两列
      if (data.formAttribute.displayOneLine === 1) {
        classes.push('card-form-line');
      }
    } else {
      // 根据displayOneLine的具体值添加对应类名
      const displayMap = {
        1: 'card-form-line',
        2: 'one-third',
        3: 'two-thirds'
      };
      if (Object.prototype.hasOwnProperty.call(displayMap, displayOneLine)) {
        classes.push(displayMap[displayOneLine]);
      }
    }
  }
  return classes;
};

// 移动分组弹窗确认
const moveModalHandleOk = () => {
  moveModalFormRef.value.handleSubmit();
  return false;
};
// 将当前分组移出
const removeFromGroup = async (fIndex, index) => {
  visibleInput.value = false;
  nextTick(() => {
    visibleInput.value = true;
  });
  const moveData = JSON.parse(JSON.stringify(tabDetailList.value[data.tabIndex]?.modules[fIndex]?.modules[index]));
  if (moveData.id && moveData?.modules?.length > 0) {
    await updateNestedArrayValues(moveData);
  }
  tabDetailList.value[data.tabIndex]?.modules[fIndex]?.modules.splice(index, 1);
  const target = tabDetailList.value[data.tabIndex];
  target.modules.push(moveData);
  emits('cb');
  handleCancel('moveModalVisible');
};
// 移动分组弹窗确认事件
const moveModalSubmit = async ({ errors }) => {
  if (errors) {
    return;
  }
  let moveData;
  const index = data.moveToGroupData[0];
  const i = data.moveToGroupData[1];
  if (i > -1) {
    moveData = JSON.parse(JSON.stringify(tabDetailList.value[data.tabIndex]?.modules[index]?.modules[i]));
    tabDetailList.value[data.tabIndex]?.modules[index]?.modules.splice(i, 1);
  } else {
    moveData = JSON.parse(JSON.stringify(tabDetailList.value[data.tabIndex]?.modules[index]));
    tabDetailList.value[data.tabIndex]?.modules.splice(index, 1);
  }
  if (moveData.id && moveData?.modules?.length > 0) {
    await updateNestedArrayValues(moveData);
  }
  const target = tabDetailList.value[data.tabIndex]?.modules[data.moveToGroupForm.selectdata];
  target.modules.push(moveData);
  emits('cb');
  handleCancel('moveModalVisible');
};
// 计算属性判断当前分组是否存在二级分组
const isSecondLevel = computed(() => {
  return (data) => {
    return !data.modules?.find((item) => item.type == 10);
  };
});
//复制到其他布局
// 打开弹窗
const handleClick = async (element, type) => {
  visible.value = false;
  visibleInput.value = false;
  nextTick(() => {
    visible.value = true;
    visibleInput.value = true;
  });
  if (element.id && element?.modules?.length > 0) {
    await updateNestedArrayValues(element);
  }
  copyToOtherLayoutData.value = { ...element, label: (element.label ? element.label : '未命名分组') + '_拷贝' };
  data.modalType = type;
  data.form.selectdata = null;
  data.modalVisible = true;
  if (!selectList.value || selectList.value.length < 1) {
    //如果当前请求过布局数据，则不需要再次请求
    await getSimpleListByEntity();
  }
};
// 获取 其他页签 下列表
const getSimpleListByEntity = async () => {
  selectLoading.value = true;
  try {
    const params = {
      entity: Number(pId),
      id: props.layoutId
    };
    const json = await setService.layoutTab(params);
    selectLoading.value = false;
    if (!json.error) {
      selectList.value = json.result;
    } else {
      Message.error(json.error?.msg || '操作失败');
    }
  } catch (e) {
    selectLoading.value = false;
    Message.error(e.message || e.statusText || '操作失败');
  }
};
// 弹窗确认
const handleOk = () => {
  formRef.value.handleSubmit();
  return false;
};
// 弹窗取消
const handleCancel = (type) => {
  data[type] = false;
};
// 弹窗确认事件
const handleSubmit = ({ errors }) => {
  if (errors) {
    return;
  }
  if (data.modalType === 10) {
    saveCopy(10, data.form.selectdata[0], data.form.selectdata[1]); //保存
  } else {
    saveCopy(20, data.form.selectdata, null); //保存
  }
};
// 将分组复制到其他页签弹窗确认
const copyToOtherOk = () => {
  copyToOtherRef.value.handleSubmit();
  return false;
};
// 将分组复制到其他页签弹窗取消
const copyToOtherCancel = () => {
  data.copyToOtherVisible = false;
};
// 将分组复制到其他页签弹窗确认事件
const copyToOtherSubmit = ({ errors }) => {
  if (errors) {
    return;
  }
  const target = tabDetailList.value[data.copyToOtherForm.selectdata];
  target.modules.push(copyToOtherItem.value);
  emits('cb');
  copyToOtherCancel();
  nextTick(() => {
    const _index = data.copyToOtherForm.selectdata;
    switchTabs(tabDetailList.value[_index], _index);
    nextTick(() => {
      //   const dom = document.getElementsByClassName('active-drag-item')[0];
      //   dom.scrollIntoView({ behavior: 'smooth', inline: 'center' }); //将当前选中页签滚动到可视范围且水平居中 smooth：平滑过渡
      const parentDom = document.getElementsByClassName('draggable-detail-content')[0];
      const doms = parentDom.querySelectorAll('.draggable-detail-content-item');
      const dom = doms[doms.length - 1];
      const domHead = dom.querySelectorAll('.drag-item-title')[0];
      domHead.scrollIntoView({ behavior: 'smooth', block: 'center' }); //将当前选中页签滚动到可视范围且垂直居中 smooth：平滑过渡
    });
  });
};
const saveCopy = async (type, id, moduleId) => {
  try {
    const params = {
      id: id, //布局id
      type: type, //拷贝类型：10 复制到其他布局页签；20 复制到其他布局
      moduleId: moduleId, //页签id，没有为null
      module: copyToOtherLayoutData.value //复制内容
    };
    const res = await setService.layoutCopy(params);
    data.form.selectdata = null;
    if (!res.error) {
      Message.success(t('操作成功'));
      //   emits('cb');
      handleCancel('modalVisible');
    } else {
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (error) {
    console.log(error);
  }
};
// 新增页签
const addTabPage = async (item) => {
  console.log('新增页签', item);
  // 选中内置页签后，内置新增中删除该选项，避免重复添加
  if (item.value == 1) {
    tabDetailList.value.push({
      type: 260,
      value: null,
      label: item.label,
      display: 1,
      displayConditions: null,
      modules: [
        {
          type: 10,
          value: null,
          label: '',
          display: 1,
          displayConditions: null,
          modules: []
        }
      ]
    });
  } else {
    tabDetailList.value.push({
      type: 260,
      label: item.label,
      display: 1,
      displayConditions: null,
      value: item.value,
      modules: [
        {
          type: 10,
          value: null,
          label: item.label,
          display: 1,
          displayConditions: null,
          modules: []
        }
      ]
    });
  }
  if (tabScrollRef.value.$el.scrollWidth > tabScrollRef.value.$el.offsetWidth) {
    await nextTick(() => {
      //滚动到最后并且切换tab页到新增的最后一个
      document.querySelector('.drag-content').scrollLeft = tabScrollRef.value.$el.scrollWidth;
      const _index = tabDetailList.value.length - 1;
      switchTabs(tabDetailList.value[_index], _index);
      // tabScrollRef.value.$el.scrollLeft = tabScrollRef.value.$el.scrollWidth;
      console.log(171, tabScrollRef.value.$el.scrollLeft, tabScrollRef.value.$el.scrollWidth);
    });
  } else {
    const _index = tabDetailList.value.length - 1;
    switchTabs(tabDetailList.value[_index], _index);
  }
};
// 删除页签内分组
const deleteGroup = (index, i) => {
  console.log(219, index);
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('tips.isDeleteGroup'),
    content: t('tips.isDeleteGroupContent'),
    onOk: () => {
      // 删除页签内二级分组
      if (i > -1) {
        tabDetailList.value[data.tabIndex]?.modules[index]?.modules.splice(i, 1);
      } else {
        tabDetailList.value[data.tabIndex]?.modules.splice(index, 1);
      }
    }
  });
};
// 子字段点之前需要清空其他子字段的选中状态
const clearSubFormStatus = () => {
  if (subFormDataRefs) {
    for (const i in subFormDataRefs) {
      subFormDataRefs[i]?.setClickStatus();
    }
  }
};
// 分组内每个字段的点击事件
const selectContentItem = (groupIndex, index, sIndex, record, type, isSubForm = false) => {
  console.log('selectType', type);
  if (entityStore.entityGray && splitType?.value) {
    if (splitType?.value === 2 || (splitType?.value === 3 && !['table', 'outLink'].includes(type))) {
      return;
    }
  }

  if (type === 'table') {
    if (record?.version == 1) {
      //从表单设计添加不支持点击
      return;
    }
    activeTable.value = true;
    activeField.value = false;
    activeTab.value = false;
  } else {
    activeTable.value = false;
    activeField.value = true;
    activeTab.value = false;
  }
  clickIndex.value = index;
  parentIndex.value = groupIndex;
  sonIndex.value = sIndex;

  if (record?.parentFieldType == 27) {
    //点击的子字段
    clickIndex.value = -1;
    parentIndex.value = -1;
    sonIndex.value = -1;
  } else {
    clearSubFormStatus();
  }

  emits('sendData', { page: 20, groupIndex, index, area: 'field', modules: record, active: 'details', isSubForm });
  console.log(216, record);
};
// 分组内的字段删除
const deleteContentItem = (groupIndex, index, i, item) => {
  if (i > -1) {
    //二级分组内删除字段
    tabDetailList.value[data.tabIndex]?.modules[groupIndex]?.modules[index]?.modules.splice(i, 1);
  } else {
    tabDetailList.value[data.tabIndex]?.modules[groupIndex]?.modules.splice(index, 1);
  }
  emits('sendData', { delete: true, modules: [item] });
};
// 添加新分组
const addNewGroup = async (index) => {
  let target;
  if (index > -1) {
    //新增二级分组
    // 先判断是哪个页签下的哪个分组的添加新分组
    target = tabDetailList.value[data.tabIndex].modules[index];
    target.modules.push({ type: 10, label: '', value: '', modules: [] });
    nextTick(() => {
      const parentDom = document.getElementsByClassName('draggable-detail-content')[0];
      const doms = parentDom.querySelectorAll('.draggable-detail-content-item');
      const dom = doms[index];
      const domHeads = dom.querySelectorAll('.drag-item-title');
      const domHead = domHeads[domHeads.length - 1];
      domHead.scrollIntoView({ behavior: 'smooth', block: 'center' }); //将当前选中页签滚动到可视范围且垂直居中 smooth：平滑过渡
    });
  } else {
    // 先判断是哪个页签下的添加新分组
    target = tabDetailList.value[data.tabIndex];
    console.log(209, target, tabDetailList.value, groupListRef.value);
    target.modules.push({ type: 10, label: '', value: '', modules: [] });
    emits('cb');
    // await nextTick(() => {
    //   groupListRef.value.$el.scrollTop = groupListRef.value.$el.scrollHeight;
    // });
    console.log(292, groupListRef.value.$el.scrollTop, groupListRef.value.$el.scrollHeight);
  }
};
provide('publicMethods', {
  sendModule: selectContentItem,
  clearSubFormStatus: clearSubFormStatus
});
// 页签排序移动事件
const onMoveTab = (e) => {
  delete e.draggedContext.element.id;
  delete e.draggedContext.element.parentId;
  if (activeTab.value) return;
};
// 拖动事件
const onMove = (e) => {
  console.log('eeeeeeeeeeeeeeee', e);
  const layoutFieldType = e.draggedContext?.element?.layoutFieldType ? e.draggedContext?.element?.layoutFieldType : e.draggedContext?.element?.type;
  // 控制拖拽：
  //   1、字段不能往最外层拖拽
  //   2、含有二级分组的分组不能拖拽到其他分组内
  //   3、任何分组不能拖拽到二级分组的分组内
  //   4、分组不能拖进摘要区
  if ((layoutFieldType != 10 && e.to.className == 'draggable-detail-content') || (layoutFieldType == 10 && e.to.className.split(' ').find((item) => item == 'abstract-class' || item == 'draggable-abstract3'))) {
    // 阻止拖拽操作
    return false;
  } else if (e.draggedContext?.element?.modules?.find((item) => item.type == 10) && e.to.className != 'draggable-detail-content') {
    return false;
  }
  //页签内字段如果不是20类型，不能拖拽到摘要区
  else if (e.to.className.split(' ').find((item) => item == 'abstract-class') && e.draggedContext.element.layoutFieldType != 20) {
    return false;
  }

  delete e.draggedContext?.element?.id;
  delete e.draggedContext?.element?.parentId;
  if (activeTab.value) return;
  //   emits('sendData', { page: 20, groupIndex: null, index: null, area: 'field', modules: null, active: 'details', activeFieldValue: activeFieldValue.value });
};
const onShow = () => {};

const onHide = () => {
  visibleInput.value = false;
  visible.value = false;
  nextTick(() => {
    visibleInput.value = true;
    visible.value = true;
  });
};

const eventListen = () => {
  if (document.visibilityState === 'visible') {
    onShow();
  } else if (document.visibilityState === 'hidden') {
    onHide();
  }
};
// 模拟页面显示的效果
onMounted(() => {
  focusEl.value = false;
  onShow();
});
//监听事件
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
eventListener('visibilitychange', eventListen, document);
// eventListener('wheel', onHide, document);

watch(
  () => props.tabList,
  (v) => {
    console.log('tab页监听数据变化', v);
    emits('update:tabList', v);
    tabDetailList.value = v;
    tabDetailListSelect.value = v.map((el, index) => ({ label: el.label, value: index })).filter((item, i) => i != data.tabIndex);
  },
  {
    // immediate: true,
    deep: true
  }
);
watch(
  () => data.tabIndex,
  () => {
    tabDetailListSelect.value = tabDetailList.value.map((el, index) => ({ label: el.label, value: index })).filter((item, i) => i != data.tabIndex);
  },
  {
    deep: true
  }
);
watch(
  () => tabDetailList.value[data.tabIndex],
  () => {
    if (!activeTab.value) {
      updataConfig();
    }
  },
  {
    deep: true
  }
);
const curDragItemClass = ref('');
// 被拖拽元素
const ghostClass = ref('ghost-dragg');
watch(
  () => useLayout.dragList,
  (v) => {
    console.log('被拖拽元素', v, data.formAttribute);
    const isOneLine = [18, 26, 27].includes(v?.fieldType) || [30, 31, 35, 60].includes(Number(v.layoutFieldType)) || data.formAttribute.displayOneLine == 1;
    ghostClass.value = isOneLine ? 'ghost-dragg-oneline' : 'ghost-dragg';
    if (data.formAttribute.displayOneLine == 1) {
      curDragItemClass.value = 'card-form-line';
    }
  },
  {
    deep: true
  }
);
defineExpose({
  addNewGroup
});
</script>
<style scoped lang="less">
@import './tab-detail-area.less';
</style>
